// For these error codes we display the raw error_msg from the vendor instead
// of a static translation of the error_code.
export const ERROR_MESSAGE_CODES = new Set([
  "kisc_error",
  "kisc_unavailable",
  "kisc_vendor_error",
]);

// Translations for vendor-level error codes embedded in the KISC error_msg JSON payload.
// Keyed by lowercased value of the "error" field. Unknown errors fall back to "Сервис ЦОИД недоступен".
export const KISC_ERROR_TRANSLATIONS = {
  iin_not_found: {
    msg: "Данные по ИИН не найдены в гос. базе",
    tooltip: "Убедитесь, что номер введен без ошибок.",
  },
  document_not_found: {
    msg: "Данные документа не найдены в гос. базе",
    tooltip: [
      "Причины ошибки \"Документ не найден в ЦОИД\":",
      "Клиент — нерезидент РК.",
      "Новое удостоверение личности готово, но не забрано из ЦОН.",
      "Иные технические или регистрационные ошибки на стороне госорганов.",
    ],
  },
  gbdfl_photo_not_found: {
    msg: "Данные документа не найдены в гос. базе",
    tooltip: [
      "Фотография документа не найдена в гос. базе.",
      "Документ устарел и не содержит фото в ГБД ФЛ, либо данные еще не обновились.",
      "Рекомендуется обновление документа.",
    ],
  },
};

export const ERROR_CODE_TRANSLATIONS = {
  // verilive
  virtual_camera_risk: {
    msg: "Подозрение на виртуальную камеру",
    tooltip: [
      "Если срабатывание является ложным, можно отключить дополнительную проверку для конкретного person_id:",
      "Открыть раздел Anti-Fraud Settings",
      "Указать нужный person_id",
      "Отключить переключатель Virtual Camera Detection",
      "Сохранить изменения",
      "Попросить пользователя пройти повторно",
    ],
  },
  model_prediction: {
    msg: "Не прошло проверку",
    tooltip:
      "Пользователю рекомендуется изменить условия прохождения (освещение, ракурс) и повторить попытку.",
  },
  face_multiplicity_session: {
    msg: "Не прошло проверку",
    tooltip:
      "Пользователю рекомендуется изменить условия прохождения (освещение, ракурс) и повторить попытку.",
  },
  face_multiplicity_frame: {
    msg: "Не прошло проверку",
    tooltip:
      "Пользователю рекомендуется изменить условия прохождения (освещение, ракурс) и повторить попытку.",
  },
  high_velocity: {
    msg: "Не прошло проверку",
    tooltip:
      "Пользователю рекомендуется изменить условия прохождения (освещение, ракурс) и повторить попытку.",
  },
  timeout: {
    msg: "Время на прохождение сессии истекло",
  },
  closed_eyes: {
    msg: "Подозрение на закрытые глаза",
    tooltip:
      "Рекомендуем держать устройство на уровне глаз и смотреть прямо в камеру.",
  },
  no_face: {
    msg: "Лицо в кадре не обнаружено",
  },
  // veridoc
  document_not_found: {
    msg: "Документ не найден в кадре",
  },
  blurry_image: {
    msg: "Размытый скан документа",
  },
  recognition_failed: {
    msg: "Ошибка распознавания документа",
  },
  fields_check_failed: {
    msg: "Ошибка распознавания документа",
  },
  cross_side_check_failed: {
    msg: "Несовпадение сторон документа",
  },
  // redoc
  show_back_failed: {
    msg: "Не распознана задняя сторона документа",
  },
  show_front_failed: {
    msg: "Не распознана лицевая сторона документа",
  },
  // egov-doc
  invalid_access_code: {
    msg: "Код доступа не найден или неактивен",
  },
  upstream_unavailable: {
    msg: "Недоступность гос. сервиса",
  },
  // kisc
  faces_mismatch: {
    msg: "Сличение на стороне ЦОИД не прошло",
  },
  iin_not_found: {
    msg: "Данные по ИИН не найдены в гос. базе",
    tooltip: "Убедитесь, что номер введен без ошибок.",
  },
  // esign
  401: {
    msg: "Неверный пароль ОЭЦП",
  },
  365: {
    msg: "Срок действия ОЭЦП истек",
  },
  // veriface
  mismatch: {
    msg: "Неуспешное сличение лиц",
  },
  // amlcft-service
  invalid_iin: {
    msg: "Некорректный формат ИИН",
  },
  // veriphone
  phone_not_found: {
    msg: "Номер не найден",
  },
};
